<template>
	<section
		class="flex flex-col w-full h-auto col-span-4 gap-6 lg:gap-8 panel lg:h-32 lg:flex-row lg:justify-between lg:items-center lg:justify-items-center"
		:class="['border-mx-orange border-b-4 bg-gradient-to-br from-white dark:from-mx-green-700 to-mx-orange/15 dark:to-mx-orange/25']"
	>
		<div class="flex flex-col gap-2 dark:text-mx-gray-300">
			<div class="text-xl lg:text-2xl">
				<span class="font-bold">{{ t('account-dashboard-autopay-cta.title-1') }}</span>
				 {{ t('account-dashboard-autopay-cta.title-2') }}
			</div>
			<div class="text-base lg:text-lg">
				{{ t('account-dashboard-autopay-cta.subtitle') }}
			</div>
		</div>
		<LinkButton
			v-if="!hideButton"
			variant="outline"
			size="sm"
			desktop-size="lg"
			to="/billing/payment-methods"
			class="w-full lg:w-auto"
		>
			{{ t('account-dashboard-autopay-cta.buttons.enable-autopay') }}
		</LinkButton>
	</section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

interface AutopayCtaProps {
	hideButton?: boolean
}

withDefaults(defineProps<AutopayCtaProps>(), {
	hideButton: false
})
</script>
